export const BADGE_ELEMENT = "entity-badge";
